import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { initKeycloak } from './keycloak';
import { App } from './ui/App';
import './styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

const root = createRoot(container);

// Nothing renders before an identity exists: every API call needs a token, and
// a half-rendered editor that cannot load or save is worse than a wait.
initKeycloak()
  .then((authenticated) => {
    if (!authenticated) {
      root.render(<p className="fatal">Not signed in.</p>);
      return;
    }
    root.render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  })
  .catch((cause: unknown) => {
    root.render(
      <p className="fatal">
        Could not reach Keycloak: {cause instanceof Error ? cause.message : String(cause)}
      </p>,
    );
  });
